<template>
  <el-upload
    class="singleimg-uploader"
    :action="uploadImg"
    :show-file-list="false"
    accept=".webp,.bmp,.pcx,.tif,.gif,.jpeg,.tag,.exif,.fpx,.svg,.png,.ico,.jpg"
    :on-success="handleSuccess"
    :on-error="handleError"
  >
    <img v-if="imageUrl!==null&&imageUrl!==''&&imageUrl!==undefined" :src="imageUrl" :style="size!==null&&size!==undefined?`width:${size[0]}px;height:${size[1]}px`:''" class="singleimg">
    <i v-else class="el-icon-plus singleimg-uploader-icon" :style="size!==null&&size!==undefined?`width:${size[0]}px;height:${size[1]}px;line-height:${size[1]}px;`:''"></i>
  </el-upload>
</template>

<script>
export default {
  name: 'SingleImg',
  props: {
    value: {
      type: Object
    },
    oldurl: {
      type: String
    },
    size: {
      type: Array
    }
  },
  data() {
    return {
      uploadImg: process.env.VUE_APP_BASE_API + '/fileUpload/uploadImg',
      imageUrl: ''
    }
  },
  watch: {
    oldurl(newVal) {
      this.imageUrl = newVal || ''
    }
  },
  created() {
    this.imageUrl = this.oldurl
  },
  methods: {
    handleSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      const data = { imgid: res.data.dImgid, img_url: res.data.img_url, imgurl: this.imageUrl }
      this.$emit('input', data)
    },
    handleError() {
      this.$message({
        type: 'error',
        message: '图片上传失败，请稍后重试'
      })
    }
  }
}
</script>

